<!--
  jntAthdcAth.vue ( 2-4 step, mblElcSgn14 )
  - 공인인증
 -->
<template>
  <div id="wrap" class="wrap_layout">
    <Header type="type_certify" />
    <div class="container">
      <div class="contents">
        <!--Contents Area [s]-->
        <div class="section">
          <p class="txt">
            고객님의 안전을 위해 본인 확인 후 진행하겠습니다.<br />성명,
            {{ isRpsMbl ? "주민등록번호" : "생년월일" }}을 입력하신 후
            공동인증서 인증을 해주세요.
          </p>
          <p class="tit_tbl">본인확인</p>
          <div class="data_table type_row">
            <table>
              <caption class="blind">
                본인확인
              </caption>
              <colgroup>
                <col style="width: 25%" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row"><label for="name_label">성명</label></th>
                  <td>
                    <input
                      id="name_label"
                      @input="state.fnm = $event.target.value.trim()"
                      type="text"
                      class="inputBox"
                      placeholder="성명 입력"
                    />
                  </td>
                </tr>
                <tr>
                  <th scope="row">
                    <label
                      for="birth_label"
                      :class="isRpsMbl ? 'keepAll' : ''"
                      >{{ isRpsMbl ? "주민등록번호" : "생년월일" }}</label
                    >
                  </th>
                  <td>
                    <input
                      id="name_label"
                      v-model="state.bdt"
                      type="tel"
                      class="inputBox"
                      :placeholder="
                        isRpsMbl ? '예)810101(6자리)' : '예) 19810101(8자리)'
                      "
                      :maxlength="isRpsMbl ? 6 : 8"
                      :class="isRpsMbl ? 'multiCol' : ''"
                    />
                    <span class="hyphen" v-if="isRpsMbl">-</span>
                    <input
                      type="password"
                      id="idfNo"
                      name="idfNo"
                      v-if="isRpsMbl"
                      class="inputBox multiCol"
                      maxLength="7"
                      placeholder="●●●●●●●"
                      ref="idfNoEl"
                      data-tk-kbdType="number"
                      onfocus="mtk.onKeyboard(this);"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <ul class="txt_list">
            <li>
              공동인증서는 인터넷 뱅킹이나 증권거래를 위해 은행 또는 증권사에서
              발급 받은 공동인증서를 사용하십시오.
            </li>
            <li>
              공동인증서 관리를 위해 별도의 어플리케이션(앱프리) 설치가
              필요합니다.
            </li>
            <li>
              입력하신 개인정보는 본인 확인 용도로만 사용되며 메리츠 화재의
              개인정보보호 정책에 따라 철저하게 보호됩니다.
            </li>
            <li>
              본인인증만 공동인증서로 진행되며, 모바일전자서명은 모바일 내
              서명패드를 통해 직접 서명하셔야 합니다.
            </li>
          </ul>
          <div class="btn_area">
            <button type="button" class="btn_main w100p" @click="sign">
              <span>공동인증서 인증</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import { reactive, inject, onMounted, computed, ref } from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";
import util from "@/common/util";
import { sessionUserInfo, load } from "@/common/sessionFactory";
import useDialog from "@/common/dialog";
import athdcWrapper from "@/common/athdc/athdcWrapper";

export default {
  name: "jntAthdcAth",
  components: {
    Header,
    Footer,
  },
  setup(props, context) {
    const store = useStore();
    const router = useRouter();
    const axios = inject("axios");
    const dialog = useDialog(inject("$vfm"));

    const isRpsMbl = computed(() => store.state.elcSgnInf.isRpsMbl);

    const idfNoEl = ref(null);

    onMounted(async () => {
      await load();

      if (!store.state.elcSgnInf.isRpsMbl) {
        if (sessionUserInfo == null) {
          router.push({ name: "sessionExpired" });
          return;
        }
        if (sessionUserInfo.inqStdDt < state.currDate) {
          router.push({ name: "usePrdExpired" });
        }
      } else if (store.state.elcSgnInf.isRpsMbl) {
        transkey = [];
        mtk = null;
        tk_btn_arr = [];
        setTimeout(initmTranskey, 500);
      }
      util.saveLog("009", "공인인증서인증번호입력"); // 009 : 화면진입
    });

    const state = reactive({
      currDate: util.formatDate(new Date(), "yyyymmdd"),
      fnm: "",
      bdt: "",
    });

    const sign = () => {
      let dialogMsg = "";

      let isRpsMbl = store.state.elcSgnInf.isRpsMbl;

      if (util.isNull(state.fnm) || util.isEmpty(state.fnm)) {
        dialogMsg = "성명을 입력해주세요.";
      } else if (util.isNull(state.bdt) || util.isEmpty(state.bdt)) {
        dialogMsg = isRpsMbl
          ? "주민등록번호 앞자리를 입력해주세요."
          : "생년월일을 입력해주세요.";
      }

      if (!util.isEmpty(dialogMsg)) {
        dialog.alert(dialogMsg);
        return;
      }

      let indvBdt = state.bdt.substr(2, 7);

      if (isRpsMbl) {
        let validBdt = util.replaceNum(state.bdt);

        if (!util.isNumeric(validBdt)) {
          dialog.alert("주민등록번호를 숫자로만 입력해주세요.");
          return false;
        } else if (validBdt.length != 6) {
          dialog.alert("주민등록번호 앞자리를 입력해주세요.");
          return false;
        } else if (util.isEmpty(idfNoEl.value.value)) {
          dialog.alert("주민등록번호 뒷자리를 입력해주세요.");
          return false;
        }

        let inputData = util.getMobileInputEncData(["idfNo"]);
        inputData.title = "idfNo";
        axios.reqPost("/solution/decodeIdf.do", inputData).then((result) => {
          let decodeFlag = result.data.decodeFlag;
          if (decodeFlag) {
            axios
              .json("/inspe/retrieveMblElcSgnEcusProgInf.do", {
                rcipeIdfNo: state.bdt,
                inqStdDt: state.currDate,
                inqCtnsKdCd: "120445",
                prctrInfInqYn: "1",
                sgnCompInclYn: "",
              })
              .then((res) => {
                if (res.data.mblElcSgnEcusProgInfBcVo.length == 0) {
                  if (res.data.body.length == 0) {
                    dialog.alert(
                      "메리츠화재 전산에 등록된 고객명과 일치하지 않습니다."
                    );
                  } else {
                    // 발송건 조회 실패로 인증 X
                    dialog.alert(
                      "피보험자 전자서명을 진행할 대상 건이 없습니다."
                    );
                  }
                } else {
                  let cusNo = res.data.mblElcSgnEcusProgInfBcVo[0].rcipeCusNo;
                  let cusNm = res.data.mblElcSgnEcusProgInfBcVo[0].rcipeNm;

                  if (cusNm == state.fnm) {
                    store.commit(
                      "elcSgnInf/changeMblElcSgnEcusProgInfBcVo",
                      res.data.mblElcSgnEcusProgInfBcVo
                    );
                    store.commit(
                      "elcSgnInf/changeCusInfo",
                      res.data.cusInfoMap.body
                    );
                    // 입력한 이름 , 생년월일 비교
                    athdcWrapper.sign({}, athdcSignCallback);
                  } else {
                    dialog.alert(
                      "메리츠화재 전산에 등록된 고객명과 일치하지 않습니다."
                    );
                  }
                }
              });
          }
        });
      } else {
        // 입력한 이름 , 생년월일 비교
        if (
          sessionUserInfo.slzCusNm == state.fnm &&
          sessionUserInfo.bdtIdfNo == indvBdt
        ) {
          athdcWrapper.sign({}, athdcSignCallback);
        } else {
          dialog.alert(
            "죄송합니다. 모바일 전자서명은 고객님 본인이 직접 인증하셔야 합니다."
          );
          return;
        }
      }
    };

    function athdcSignCallback(result, param) {
      if (result.status == "1") {
        mobileLginOfapvAthdc(result, param);
      } else if (result.status == "0") {
        dialog.alert("인증서 선택을 취소 하였습니다. ");
      } else {
        dialog.alert(
          "전자서명 오류:" + result.message + "[" + result.status + "]"
        );
      }
    }

    function mobileLginOfapvAthdc(data, param) {
      var pm = {
        signed_msg: data.data, //인증서 서명 데이터
        vid_msg: data.vidRandom, //인성서 본인확인용 vid값
      };

      //공인인증서 입력한 식별번호랑 비교
      axios.reqPost("/Appfree/jsp/ofapvAthVrf.jsp", pm).then(function (result) {
        if (result.data.errorCode1 < 0) {
          dialog.alert(
            "인증서의 유효기간이 만료되었거나 검증되지 않은 인증서입니다. 인증서를 다시 확인해 주세요."
          );
        } else {
          if (result.data.errorCode2 < 0) {
            if (result.data.errorCode2 == "-107") {
              dialog.alert(
                "인증서의 소유자가 다릅니다.<br> 다시 확인해 주세요."
              );
            } else {
              dialog.alert(
                "인증서의 유효기간이 만료되었거나 검증되지 않은 인증서입니다. 인증서를 다시 확인해 주세요."
              );
            }
          } else {
            dialog.alert("정상적으로 인증되었습니다.").then(function () {
              let serialNum = result.data.serialNum;
              var param = {};
              param.prctrNo = sessionUserInfo.prctrNo;
              param.athNo = serialNum;
              param.ctnsKdCd = sessionUserInfo.ctnsKdCd;
              param.orgCd = sessionUserInfo.orgCd;
              param.cusNo = sessionUserInfo.cusNo;
              param.pcsCtnsSndReqId = sessionUserInfo.dataId;
              param.elcSgnSelfAthMdCd = "04";

              if (!store.state.elcSgnInf.isRpsMbl) {
                axios
                  .json("/registPrtblAthNo.do", param)
                  .then(function (result) {
                    router.push({ name: "ctrBasMttCnf" });
                    context.emit("close");
                  });
              } else {
                store.commit("elcSgnInf/changeAthData", param);
                router.push({ name: "ctrLstCho" });
              }
            });
          }
        }
      });
    }

    return {
      state,
      load,
      sessionUserInfo,
      sign,
      isRpsMbl,
      idfNoEl,
    };
  },
};
</script>

<style scoped>
.hyphen {
  width: 6%;
  text-align: center;
}

.multiCol {
  width: 47%;
}

.keepAll {
  word-break: keep-all;
}
</style>
